import SimpleParallax from './vendor/parallax/vanilla';

jQuery(document).ready(function ($) {
  "use strict";

  let threshold = 0;

  if (window.matchMedia('(hover: hover)').matches) {
    threshold = 1;
  }

  /*
   * Animate
   **/

  const animations = document.querySelectorAll('.has-animation, .has-intersect');

  animations.forEach((el) => {
    el.addEventListener("animationend", () => {
      $(el).addClass('has-animated');
    });
  });

  /*
  * Intersects
  **/

  let observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        $(entry.target).addClass('has-intersected');
        observer.unobserve(entry.target)
      }
    })
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0
  });

  document.querySelectorAll('.has-intersect').forEach(entry => {
    observer.observe(entry);
  });

  /*
  * Parallax
  **/

  const elements = document.querySelectorAll('.has-parallax');

  elements.forEach((el) => {
    let parallaxType = $(el).attr('data-parallax-type');
    let parallaxScale = 1.2;

    if (parallaxType) {
      if (parallaxType == 'left' | parallaxType == 'right') {
        parallaxScale = 1.1;
      }

      new SimpleParallax(el, {
        delay: 0.6,
        orientation: parallaxType,
        scale: parallaxScale,
        transition: 'cubic-bezier(0,0,0,1)',
        customContainer: '',
        customWrapper: '',
      });
    }
  });

  /*
   * Helpers
   **/

  $('.wp-block-button__link').each(function (el) {
    let text = $(this).html();

    $(this).empty().html(function () {
      $(this).html('<span class="link-label">' + text + '</span>');
    });
  });
});
